import { render, staticRenderFns } from "./colors-legend.vue?vue&type=template&id=63f73b55&scoped=true&"
import script from "./colors-legend.vue?vue&type=script&lang=js&"
export * from "./colors-legend.vue?vue&type=script&lang=js&"
import style0 from "./colors-legend.vue?vue&type=style&index=0&id=63f73b55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f73b55",
  null
  
)

export default component.exports